import React, { PureComponent } from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import SvgIcon from 'material-ui/SvgIcon';
import {leftArrowBold, rightArrowBold} from 'shared/icons/index';
import { store } from 'App/store';
import updateQuery from 'shared/helpers/updateQuery';
import * as Colors from 'material-ui/styles/colors';
import _ from 'lodash';
import { zIndexMouseCatcher } from 'crazyEditor/core/globals';
import {setViewMode} from 'crazyEditor/core/utils/stageUtils';
import { VIEW_MODES } from 'crazyEditor/core/constants/editorConstants';
import {getTemplatesBySelectedTag} from 'shared/selectors/templatesSelectors';
import connectWithRouter, {getStateWithRouting} from 'shared/components/redux/connectWithRouter';

@connectWithRouter(
  (state) => ({
    isQuickPreviewMode: state.editor.isQuickPreviewMode,
    templateId: state.routing.location.query.id,
  })
)
export default class QuickPreviewArrows extends PureComponent {

  getNextPrevTemplateIds() {
    const {templateId} = this.props;
    const templateList = getTemplatesBySelectedTag(getStateWithRouting(store.getState(), this.props));
    const templateIds = _.keys(templateList);
    const currentTemplateIndex = templateIds.indexOf(templateId);
    const result = {};
    result.next = templateIds[currentTemplateIndex === 0 ? templateIds.length - 1 : currentTemplateIndex - 1];
    result.prev = templateIds[currentTemplateIndex === templateIds.length - 1 ? 0 : currentTemplateIndex + 1];
    return result;
  }

  goToTemplate(id) {
    const templateList = getTemplatesBySelectedTag(getStateWithRouting(store.getState(), this.props));
    if (templateList[id] && !templateList[id].mobileOptimized) {
      setViewMode(VIEW_MODES.DESKTOP);
    }
    updateQuery({id}, true);
  }

  render() {
    const {isQuickPreviewMode} = this.props;
    const {next, prev} = this.getNextPrevTemplateIds();
    if (!isQuickPreviewMode) {
      return null;
    }
    return (
      <div>
        <FloatingActionButton
          style={{position: 'fixed', transform: 'translateY(-50%)', top: '50%', left: 'calc(18% - 150px)', zIndex: zIndexMouseCatcher}}
          iconStyle={{color: Colors.grey700}}
          backgroundColor = {Colors.grey500}
          onClick = {this.goToTemplate.bind(this, prev)}
        >
          <SvgIcon style={{width: 44}}>
            <path d={leftArrowBold} />
          </SvgIcon>
        </FloatingActionButton>
        <FloatingActionButton
          style={{position: 'fixed', transform: 'translateY(-50%)', top: '50%', right: 'calc(18% - 150px)', zIndex: zIndexMouseCatcher}}
          iconStyle={{color: Colors.grey700}}
          backgroundColor = {Colors.grey500}
          onClick = {this.goToTemplate.bind(this, next)}
        >
          <SvgIcon style={{width: 44}}>
            <path d={rightArrowBold} />
          </SvgIcon>
        </FloatingActionButton>
      </div>
    );
  }
}
